import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import GetHistoryImage from './GetHistoryImage'

const copy = {
  heading: `Get a holistic view of each customer with identity resolution`,
  description: `Explore all your user profiles in one place. Stitch together each customer’s journey between multiple user sessions and devices with deterministic identity resolution, while enabling centralized privacy and governance.`,
}

const GetHistory: FC = () => (
  <StyledSectionBase variant="2Col">
    <Section.Contents>
      <GetHistoryImage alt={`Illustration: ${copy.heading}`} />
    </Section.Contents>
    <StyledCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Heading tag="h2" variant="h2">
          {copy.heading}
        </CopyText.Heading>
        <CopyText.Description tag="p" variant="pLarge">
          {copy.description}
        </CopyText.Description>
      </CopyTextBase>
    </StyledCopy>
  </StyledSectionBase>
)

export default GetHistory

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`
